export enum SubStrategyType {
    CARD = 'card_ui',
    NONE = 'none',
    UNSUPPORTED = 'unsupported',
}
